import { DatePipe, NgIf } from '@angular/common';
import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ApprovalHistoryTablesEnum } from '@app/enums';
import { ApprovalHistoryItemModel } from './approval-history-item.model';
import { ApprovalHistoryService } from './services/approval-history.service';
import { NoDataAvailableComponent } from '../no-data-available/no-data-available.component';

@Component({
    selector: 'shared-approval-history',
    templateUrl: './approval-history.component.html',
    styleUrls: ['./approval-history.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        MatButtonModule,
        MatBadgeModule,
        MatMenuModule,
        MatIconModule,
        MatTableModule,
        NgIf,
        NoDataAvailableComponent,
        DatePipe,
    ],
})
export class ApprovalHistoryComponent implements OnInit {
	@ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
	@Input() entity: { id: number; table: ApprovalHistoryTablesEnum };

	dataSource = new MatTableDataSource<ApprovalHistoryItemModel>();
	columnsToDisplay: string[] = ['EffectiveDT', 'UserName', 'ApprovalLevel'];
	approvalCount = 0;

	constructor(private readonly approvalHistoryService: ApprovalHistoryService) {}

	ngOnInit(): void {
		this.loadHistory();
	}

	closeMenu(): void {
		this.trigger.closeMenu();
	}

	private loadHistory(): void {
		if (!this.entity?.id) {
			return;
		}

		this.approvalHistoryService.getApprovalHistory(this.entity.id, this.entity.table).subscribe((data: ApprovalHistoryItemModel[]) => {
			this.dataSource = new MatTableDataSource<ApprovalHistoryItemModel>(data);
			this.approvalCount = data?.length;
		});
	}
}
